module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABBklEQVRIie2UO27CQBCGPwMVjwJRpEEQUfgWyBI3oMsdKDgTjTkCDyld0uQGXjpIkRQ5AEl4aKTFWiwbx6C1UOS/Gs94/Y3/GdsJgsAHngAHOzoAUwEdLAHOVMoDQgHSkpnubIM+gQ7wAKxsgp6Bd+ALWNgE/RhxJvv+33pXLtQ+9Ex+jdyLEb8BE+O6DPSBbtzDkn5BknsE1mmduq4bxkqpJrABatH7kqwT0HcaJEayLPu4QpJ10sArMItYJ3b5Oh4CnlLqVBPrBkAjC0jUA0aR3MQAecD4D28Zdp6L7hZkWp3p7KUZxUnm0gK2evDWQG39bckK122CRNUrzhRbdxtoaZ0C8yO4FjPKxlmsaQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/addDevice/add_new_built.png
// module id = bsTL
// module chunks = 1